import React from 'react';
import { useTranslation } from 'react-i18next';
import { mockDegree } from '../../mockDegree.json';

export default function DegreeModalInfo(props) {
  const { t } = useTranslation();
  const { tenant } = { ...props };
  const primaryColor = {
    color: `${tenant.primary}`,
  };

  return (
    <div className="pay-and-openings">
      <p className="bold">{t('Next Start Date:')}</p>
      <p className="big-font bold padding-bottom" style={primaryColor}>
        {mockDegree.startDate}
      </p>
      <p className="bold">{t('Total Classes:')}</p>
      <p className="big-font bold padding-bottom" style={primaryColor}>
        {mockDegree.totalClasses}
      </p>
      <p className="bold">{t('Fast Track:')}</p>
      <p className="big-font bold padding-bottom" style={primaryColor}>
        {mockDegree.fastTrack ? 'Eligible' : 'Not Eligible'}
      </p>
      <p className="bold">{t('Weeks Per Class:')}</p>
      <p className="big-font bold padding-bottom" style={primaryColor}>
        {mockDegree.weeksPerClass}
      </p>
    </div>
  );
}
